import { registerPlugin } from './global';
export const WebView = /*#__PURE__*/ registerPlugin('WebView');
//# sourceMappingURL=core-plugins.js.map